/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/Product",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCodeExpand(code) {
    const requestScreenData = {
      url: "api/Product",
      top: "1",
      select: "Code,Description1,Inactive,IsBatchProduct,UnitOfMeasureCode,StandardCost,StockEnquiryQuantities,BestBeforeShelfLife,UseByShelfLife",
      expand: "StockEnquiryQuantities($select=BranchCode,OnHand,ItemCode,StandardCost)",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductData(filter) {
    const requestScreenData = {
      url: "api/Product",
      filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductPurchaseList(filter, params) {
    const requestScreenData = {
      url: "api/ProductPurchaseList",
      filter,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductFullDescription(code) {
    const requestScreenData = {
      url: "api/ProductDescription",
      top: "1",
      filter: `ProductCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async checkActiveTransactions(code) {
    const requestScreenData = {
      url: "api/ProductActiveTransaction",
      top: "1",
      filter: `ProductCode eq '${code}' and (HowManyActivePurchaseOrders gt 0 or HowManyActiveSalesOrders gt 0 or HowManyActiveSalesQuotes gt 0 or HowManyActiveWorksOrders gt 0)`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async checkBatchStock(code) {
    const requestScreenData = {
      url: "api/ProductBatchStock",
      top: "1",
      filter: `ProductCode eq '${code}' and OnHand ne 0`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async checkProductStock(code) {
    const requestScreenData = {
      url: "api/ProductStock",
      top: "1",
      filter: `ProductCode eq '${code}' and OnHand ne 0`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async checkTransactions(code) {
    const requestScreenData = {
      url: "api/ItemStatistic",
      top: "1",
      filter: `ProductCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveProduct(mode, payload) {
    var url = "api/Save_Product";

    if (mode === "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.put(url, payload.Code, payload, "String");
    }
  },

  async getByCodeProductFilterGroupSaleItemCompanyBranch(params) {
    const requestScreenData = {
      url: "api/ProductFilterGroupSaleItemCompanyBranch",
      top: "1",
      filter: params.filter,
      select: params.select,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductListAll() {
    const requestScreenData = {
      url: "api/ProductListAll",
      filter: `Inactive eq 'N' and Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getStockEnquiryQuantity(params) {
    const requestScreenData = {
      url: "api/StockEnquiryQuantity",
      select: params.select,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomData(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },
  async getDefaultCategories() {
    const requestScreenData = {
      url: "api/ProductDefaultCategory",
      top: "1",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async checkProductMovements(code) {
    const requestScreenData = {
      url: "api/ItemStatistic",
      top: "1",
      filter: `ProductCode eq '${code}'`,
      select: ["ProductCode", "RecordId"]
    };

    return await ApiService.oDataGet(requestScreenData);

  },

  async getProductList(params) {
    const requestScreenData = {
      url: "api/ProductList"
    };

    if (params) {
      if (params.filter) requestScreenData.filter = params.filter;
    }


    return await ApiService.oDataGet(requestScreenData);
  }
};

export { ProductService };
